import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    DrawerWrapper: {
        width: "35vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "#f5f6fa",
        padding: "16px",
    },
    OpeningEntriesWrapper: {
        marginTop: "1rem",
    },
    ActionButton: {
        width:'100%',
        padding: '14px'
    }
}));
